import React from 'react';
import useSimpleHousehold from 'Hooks/useSimpleHousehold';
import { AccountProvider } from 'Components/Accounts/AccountContext';
import PlannerDataTabAccountOverride from 'Overrides/PlannerDataTabAccount';
import InvestmentsRoot from './InvestmentsRoot';

function Investments() {
  const { householdResource } = useSimpleHousehold();

  if (!householdResource) {
    return null;
  }

  return (
    <AccountProvider
      accountRelationship={householdResource
        .relationship('accounts')
        ?.link('related')
        .in(
          'accountTypeMultipicklist',
          'non_retirement_account,personal_retirement_account,employer_sponsored_plan,education_account',
        )}
      initialState={{
        metaOverrideSet: PlannerDataTabAccountOverride,
      }}
    >
      <InvestmentsRoot />
    </AccountProvider>
  );
}

Investments.propTypes = {};

Investments.defaultProps = {};

export default Investments;
